import React, { useEffect, useState } from "react";
import "./App.scss";
import Landing from "./components/landing/Landing.js";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Footer from "./components/landing/footer/Footer.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Signupproject from "./components/Signupproject/Signupproject.js";
import Signupleader from "./components/Signupproject/Signupleader.js";
import Faqs from "./components/Faqs/Faqs.js";
import Insurance from "./components/Insurance/Insurance.js";
import Terms from "./components/Terms/Terms.js";
import Privacy from "./components/Privacy/Privacy.js";
import ApplyForMarketing from "./components/ApplyForMarketing/Apply.js";
import Career from "./components/Career/Career.js";
import Education from "./components/Education/Education.js";
import Blog from "./components/Blog/Blog.js";
import BlogDetail from "./components/Blog/BlogDetail.js";
import Aml from "./components/Privacy/AmlPolicy.js";
import GemsDetailPage from "./components/AllDetailPages/GemsDetailPage/GemsDetailPage.js";
import DopDetailPage from "./components/AllDetailPages/DopDetailPage/DopDetailPage.js";
import IncentivDetailPage from "./components/AllDetailPages/IncentivDetailPage/IncentiveDetailPage.js";
import LeiaDetailPage from "./components/AllDetailPages/LeiaDetailPage/LeiaDetailPage.js";
import OlympusDetailPage from "./components/AllDetailPages/OlympusDetailPage/OlympusDetailPage.js";
import SeeAllProjects from "./components/SeeAllProjects/SeeAllProjects.js";
import GemsPurchases from "./components/GemsPurchases/GemsPurchases.js";
// import AllPurchases from "./components/GemsPurchases/AllPurchasesPremium.js";
import Claim from "./components/GemsPurchases/Claim.js";
import Claim2 from "./components/GemsPurchases/ClaimLuckify.js";
import useEagerConnect from "./hooks/useEagerConnect";
import AllPurchasesPremium from "./components/GemsPurchases/AllPurchasesPremium.js";
import AllPurchasesReferral from "./components/GemsPurchases/AllPurchasesReferral.js";
import NFADetailpage from "./components/AllDetailPages/NFADetailPage/NFADetailpage.js";
import GemsDetailToken from "./components/AllDetailPages/GemsDetailToken/GemsDetailToken.js";
import GemsCommunityProject from "./components/GemsCommunityProject/GemsCommunityProject.js";
import TakeSurvey from "./components/GemsCommunityProject/TakeSurvey.js";
import TermsForCommunnity from "./components/Terms/TermsForCommunity.js";
import AstraDetailPage from "./components/AllDetailPages/AstraDetailPage/AstraDetailPage.js";
import NodesMinersLanding from "./components/NodesMinersLanding/NodesMinersLanding.js";
import NodesDetailPage from "./components/AllDetailPages/NodesDetailPage/NodesDetailPage.js";
import MinersDetailPage from "./components/AllDetailPages/MinersDetailPage/MinersDetailPage.js";
import RainDetailPage from "./components/AllDetailPages/RainDetailPage/RainDetailPage.js";
import ProdexDetailPage from "./components/AllDetailPages/ProdexDetailPage/ProdexDetailPage.js";
import AllPurchasesNodeMiner from "./components/GemsPurchases/AllPurchasesNodeMiner.js";
import ClaimSchedule from "./components/ClaimSchedule/ClaimSchedule.js";
import ClaimSchedule2 from "./components/ClaimSchedule/Claims/ClaimLuckify.js";
import PdfViewer from "./PdfViewer.js";
import MatchainDetailPage from "./components/AllDetailPages/MatchainDetailPage/MatchainDetailPage.js";
import Staking from "./components/Staking/Staking.js";
import Creditrefund from "./components/Creditrefund/Creditrefund.js";
import axios from "axios";
import LuckifyDetailPage from "./components/AllDetailPages/LuckifyDetailPage/LuckifyDetailPage.js";
import ScrexDetailPage from "./components/AllDetailPages/ScrexDetailPage/ScrexDetailPage.js";
import Tokenclaimdetail from "./components/VestingClaim/Tokenclaimdetail.js";
import ChainersDetailPage from "./components/AllDetailPages/ChainersDetailPage/ChainersDetailPage.js";
import TigaDetailPage from "./components/AllDetailPages/TigaDetailPage/TigaDetailPage.js";
import XprotocolDetailPage from "./components/AllDetailPages/XprotocolDetailPage/XprotocolDetailPage.js";
import Loginscreen from "./components/Loginscreen/Loginscreen.js";
import {
  Redirect,
} from "react-router-dom";
function App() {
      const isAuthenticated = localStorage.getItem("authPassword") === "Quecko@123!";

  const [countryyName, setCountryyName] = useState(null);
  const [showservice, setShowService] = useState(false);
  const handleCloseService = () => setShowService(false);
  const handleShowService = () => setShowService(true);
  useEagerConnect();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (window.self !== window.top) {
      window.top.location = window.self.location;
    }
  }, []);

  const get_ApiKeys = async () => {
    // let ipp=localStorage.getItem('ip')
    try {
      const response = await axios({
        method: "get",
        url: "https://ip.nf/me.json",
      });
      //  console.log(ipp,'response', response?.data.ip.ip);
      // if (!ipp||ipp!=response?.data.ip.ip){
      localStorage.setItem("ip", response?.data.ip.ip);
      get_ApiKeys1(response?.data.ip.ip);
      // }
    } catch (error) {
      setShowService(false);
      console.log(error, "error");
      // localStorage.setItem('ip',response?.data.ip)
      // localStorage.setItem('country',response?.data.country)
      // throw error;
    }
  };

  const get_ApiKeys1 = async (e) => {
    try {
      const response = await axios({
        method: "get",
        url: `https://api.iplocation.net/?ip=${e}`,
      });
      //  console.log(response?.data.country_name,'sdsdsdsds',);
      // localStorage.setItem('ip', response?.data.ip.ip)
      localStorage.setItem(
        "country",
        response?.data.country_name?.toLowerCase(),
      );
      // setCountryyName(response?.data.ip.country)
      // if (
      //   response?.data.country_name?.toLowerCase()?.includes("southsudan") ||
      //   response?.data.country_name?.toLowerCase()?.includes("south sudan") ||
      //   response?.data.country_name?.toLowerCase()?.includes("afghanistan") ||
      //   response?.data.country_name?.toLowerCase()?.includes("yemen") ||
      //   response?.data.country_name?.toLowerCase()?.includes("myanmar") ||
      //   response?.data.country_name?.toLowerCase()?.includes("iran") ||
      //   response?.data.country_name?.toLowerCase()?.includes("north korea") ||
      //   response?.data.country_name?.toLowerCase()?.includes("syria") ||
      //   response?.data.country_name?.toLowerCase()?.includes("lebanon") ||
      //   response?.data.country_name?.toLowerCase()?.includes("northkorea")
      // ) {
      //   setShowService(true);
      // }
      // //  }
      // else {
      //   setShowService(false);
      // }
    } catch (error) {
      setShowService(false);
      localStorage.setItem("country", "india");
      console.log(error, "error");
      // localStorage.setItem('ip',response?.data.ip)
      // localStorage.setItem('country',response?.data.country)
      // throw error;
    }
  };
  // useEffect(() => {
  //   get_ApiKeys();
  // }, []);
  return (
    <>
      <ToastContainer style={{ fontSize: 20 }} />
      <Router>
         {isAuthenticated && (
          <>
        <Switch>
          <Route exact path="/" render={() => <Landing />} />
          <Route exact path="/Gems/:name" render={() => <GemsDetailPage />} />
          <Route exact path="/gemsdetail" component={GemsDetailToken} />
          <Route exact path="/dopdetail" component={DopDetailPage} />
          <Route exact path="/incentiv" component={IncentivDetailPage} />
          <Route exact path="/leia" component={LeiaDetailPage} />
          <Route exact path="/olympus" component={OlympusDetailPage} />
          <Route exact path="/nfa" component={NFADetailpage} />
          <Route exact path="/astranova" component={AstraDetailPage} />
          <Route exact path="/rain" component={RainDetailPage} />
          <Route exact path="/prodex" component={ProdexDetailPage} />
          {/* <Route exact path="/nodes" component={NodesDetailPage} /> */}
          {/* <Route exact path="/miners" component={MinersDetailPage} /> */}
          <Route exact path="/matchain" component={MatchainDetailPage} />
          <Route exact path="/luckify" component={LuckifyDetailPage} />
          <Route exact path="/xen" component={ScrexDetailPage} />
          <Route exact path="/chainers" component={ChainersDetailPage} />
          <Route exact path="/tiga" component={TigaDetailPage} />
          <Route exact path="/xprotocol" component={XprotocolDetailPage} />
          <Route exact path="/signupforproject" component={Signupproject} />
          <Route exact path="/signupforleader" component={Signupleader} />
          <Route exact path="/faqs" component={Faqs} />
          {/* <Route exact path="/applyforcountrymanager" component={Apply} /> */}
          <Route exact path="/insurance" component={Insurance} />
          <Route exact path="/terms" component={Terms} />
          <Route
            exact
            path="/termscommunityproject"
            component={TermsForCommunnity}
          />
          <Route exact path="/privacy" component={Privacy} />
          <Route exact path="/amlpolicy" component={Aml} />
          <Route exact path="/careers" component={Career} />
          <Route exact path="/launchpad" component={SeeAllProjects} />
          <Route
            exact
            path="/applyformarketingmanager"
            component={ApplyForMarketing}
          />
          <Route exact path="/education" component={Education} />
          <Route exact path="/blog" component={Blog} />
          <Route exact path="/blog/:slug" component={BlogDetail} />
          <Route exact path="/mypurchases" component={GemsPurchases} />
          <Route
            exact
            path="/allpurchasespremium/:id"
            component={AllPurchasesPremium}
          />
          <Route
            exact
            path="/allpurchasesreferral/:id"
            component={AllPurchasesReferral}
          />
          {/* <Route
            exact
            path="/allpurchasesnodeminer/:id"
            component={AllPurchasesNodeMiner}
          /> */}
          <Route exact path="/claimall" component={Claim} />
          <Route exact path="/claimluckify" component={Claim2} />
          <Route
            exact
            path="/gemscommunityproject"
            component={GemsCommunityProject}
          />
          <Route exact path="/survey" component={TakeSurvey} />
          {/* <Route exact path="/nodes-miners" component={NodesMinersLanding} /> */}
          <Route exact path="/claimschedule" component={ClaimSchedule} />
          <Route exact path="/claims-luckify" component={ClaimSchedule2} />
          <Route exact path="/whitepaper" component={PdfViewer} />
          <Route exact path="/premium" component={Staking} />
          <Route exact path="/creditrefund" component={Creditrefund} />
          <Route exact path="/claim-detail" component={Tokenclaimdetail} />
        </Switch>
        </>
         
        )}
          <Route exact path="/loginscreen" render={() => <Loginscreen />} />
        {!isAuthenticated && <Redirect to="/loginscreen" />}
        <Footer />
       
      </Router>
    </>
  );
}

export default App;
